import { useCallback, useEffect, useState } from 'react';
import { useManualQuery } from 'graphql-hooks';

import { CATEGORIES } from '../graphql/category/query';
import { GAMES_BY_CATEGORY } from '../graphql/game';
import { Context, StateAuth, useAuth } from '../context/auth';
import { Category, Game } from '../types';

// Games of the FPS category, last added first (Warzone pinned first by the server).
// Only the FPS category is used, the other ones exist in the database but are not used.
const useFpsGames = () => {
  const { user } = useAuth() as Context;
  const isConnected = user.isConnected === StateAuth.CONNECTED;
  const [categories] = useManualQuery(CATEGORIES);
  const [gamesByCategoryId] = useManualQuery(GAMES_BY_CATEGORY);
  const [category, setCategory] = useState<Category | null>(null);
  const [games, setGames] = useState([] as Game[]);

  const getGames = useCallback(async () => {
    const { data } = await categories() as any;
    if (!data || !data.categories) {
      return;
    }
    const fps = data.categories.find((c: Category) => c.name === 'FPS');
    if (fps) {
      setCategory(fps);
      const { data: res } = await gamesByCategoryId({
        variables: {
          categoryId: fps.id,
          sort: 'RECENT',
        },
      }) as any;
      if (res && res.gamesByCategoryId) {
        setGames(res.gamesByCategoryId);
      }
    }
  }, [categories, gamesByCategoryId]);

  // Loaded again after a login without reload: a visitor gets no games.
  useEffect(() => {
    getGames();
  }, [getGames, isConnected]);

  return { category, games };
};

export default useFpsGames;
